import connectedGroupImage from '../assets/images/nodes/Groupsactive.svg';
import connectedPolicyImage from '../assets/images/nodes/Permissionsactive.svg';
import connectedRoleImage from '../assets/images/nodes/Rolesactive.svg';
import connectedResourceImage from '../assets/images/nodes/Resourcesactive.svg';
import userImage from '../assets/images/nodes/Useractive.svg';
import userCluster from '../assets/images/clsuters/user-cluster.svg';
import roleCluster from '../assets/images/clsuters/role-cluster.svg';
import groupCluster from '../assets/images/clsuters/group-cluster.svg';
import policyCluster from '../assets/images/clsuters/policy-cluster.svg';
import resourceCluster from '../assets/images/clsuters/resource-cluster.svg';
import usedEdge from '../assets/images/edges/used.svg';
import unUsedEdge from '../assets/images/edges/unused.svg';
const imageData = [{
  url: userImage,
  title: 'User'
}, {
  url: connectedGroupImage,
  title: 'Group'
}, {
  url: connectedPolicyImage,
  title: 'Policy'
}, {
  url: connectedResourceImage,
  title: 'Resource'
}, {
  url: connectedRoleImage,
  title: 'Role'
}, {
  url: userCluster,
  title: 'User Cluster'
}, {
  url: roleCluster,
  title: 'Role Cluster'
}, {
  url: policyCluster,
  title: 'Policy Cluster'
}, {
  url: groupCluster,
  title: 'Group Cluster'
}, {
  url: resourceCluster,
  title: 'Resource Cluster'
}, {
  url: usedEdge,
  title: 'Used'
}, {
  url: unUsedEdge,
  title: 'Unused'
}];
export default imageData;